export const getEndPot = ({startStack, endStack}) => {
    let endPot = 0
    for (const key in endStack) {
        endPot += startStack - endStack[key];
    }
    return endPot
}